<div class="section">
    <app-segobjectpropertymap-panel></app-segobjectpropertymap-panel>
</div>
<ng-container>
    <div class="autoCell-job-container">
        <form class="form-container job-selection-dialog-content" [formGroup]="plottingForm">
            <cds-form-group>
                <div class="experiment-name-input">
                    <cds-input controlWidth="shrink">
                        <label>Name</label>
                        <input type="text" [formControlName]="NEW_EXPERIMENT_NAME_KEY" />
                    </cds-input>
                </div>
                <div class="intensity-map-input">
                    <cds-select class="intensity-map-dropdown" controlWidth="shrink">
                        <label>Plot type</label>
                        <select [formControlName]="SELECTED_PLOT_TYPE_KEY">
                            <option *ngFor="let plot of plots">
                                {{ plot.type }}
                            </option>
                        </select>
                    </cds-select>
                </div>

                <div class="groups-container">
                    <label>Groups</label>
                    <div class="groups">
                        <div class="group" *ngFor="let group of groups">
                            <div class="group-item" *ngFor="let g of group">
                                {{ g.id }} <br /><span class="node-ids">{{
                                    getNodeIds(g.nodes)
                                }}</span>
                            </div>
                            <div class="addBtnWrapper">
                                <button (click)="removeGroup(group)">-Remove</button>
                            </div>
                        </div>
                        <div class="addBtnWrapper" *ngIf="groups.length === 0">
                            <button (click)="openGroupSelectionDialog()">+Add</button>
                        </div>
                    </div>
                </div>
                <div class="intensity-map-input">
                    <cds-select class="intensity-map-dropdown" controlWidth="shrink">
                        <label>Property</label>
                        <select [formControlName]="SELECTED_PROPERTY_KEY">
                            <option *ngFor="let property of properties">
                                {{ property }}
                            </option>
                        </select>
                    </cds-select>
                </div>
                <ng-container *ngFor="let detail of getSelectedPlotDetails()">
                    <div class="plot-option-input">
                        <cds-select *ngIf="detail.option" controlWidth="shrink">
                            <label>{{ detail.displayedName | titlecase }}</label>
                            <select [formControlName]="detail.name">
                                <option *ngFor="let opt of detail.option" [value]="opt">
                                    {{ opt }}
                                </option>
                            </select>
                        </cds-select>

                        <cds-checkbox *ngIf="!detail.option">
                            <label>{{ detail.displayedName | titlecase }}</label>
                            <input type="checkbox" [formControlName]="detail.name" />
                        </cds-checkbox>
                    </div>
                </ng-container>
            </cds-form-group>
            <div class="actions submit-button">
                <cds-button
                    size="sm"
                    (click)="startJob()"
                    [disabled]="!enableJobButton || groups.length === 0"
                >
                    Start Job
                </cds-button>
            </div>
        </form>
    </div>
</ng-container>
<div class="section" *ngFor="let plottingResult of plottingResults">
    <div class="title-row">
        <div class="left-elements">
            <label>{{ plottingResult.name }}</label>
        </div>
        <button size="sm" (click)="deleteResult(plottingResult.name)" class="icon-button">
            <cds-icon shape="trash"></cds-icon>
        </button>
    </div>
    <img
        class="result-image"
        [src]="plottingResult.image"
        (click)="openInNewTab(plottingResult.image)"
        style="cursor: pointer"
    />
    <div>
        <div class="details">
            <div class="detail-entry">Groups</div>
            <div class="groups">
                <div class="group" *ngFor="let groupItem of plottingResult.groups">
                    <ng-container *ngFor="let item of groupItem">
                        <div *ngIf="item.categorical_property" class="categorical-properties">
                            Category:<span *ngFor="let prop of item.categorical_property">
                                {{ prop.name }}
                            </span>
                        </div>
                        <div *ngIf="item.selections" class="selections">
                            Selections:
                            <span *ngFor="let selection of item.selections; let last = last">
                                {{ selection.group_name ? '[' + selection.group_name + '] ' : ''
                                }}{{ selection.name }}{{ !last ? ', ' : '' }}
                            </span>
                        </div>
                        <div *ngIf="item.cohort" class="cohort">
                            Cohort: {{ item.cohort.join(', ') }}
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
        <div class="details">
            <div class="detail-entry">Details</div>
            <div>
                <div *ngFor="let detail of plottingResult.plot_details">
                    <div *ngFor="let key of getObjectKeys(detail)">
                        <div>
                            <span>{{ key | titlecase }}: </span>
                            <span>{{ detail[key] }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
